var map = {
	"./en/macbook-en.png": 2304,
	"./en/macbook-en@2x.png": 2305,
	"./es/macbook-es.png": 2306,
	"./es/macbook-es@2x.png": 2307,
	"./ru/macbook-ru.png": 2308,
	"./ru/macbook-ru@2x.png": 2309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2303;